import { useCallback } from "react";

import type { PlayerState } from "@/store/store";

interface UsePlayerSettingsProps {
  player: PlayerState;
  setPlayer: (
    update: PlayerState | ((prev: PlayerState) => PlayerState),
  ) => void;
}

export const usePlayerSettings = ({ setPlayer }: UsePlayerSettingsProps) => {
  const setLoop = useCallback(
    (loop: boolean) => {
      setPlayer((prev) => ({ ...prev, loop }));
    },
    [setPlayer],
  );

  const setPlaybackRate = useCallback(
    (playbackRate: number) => {
      setPlayer((prev) => ({ ...prev, playbackRate }));
    },
    [setPlayer],
  );

  return {
    setLoop,
    setPlaybackRate,
  };
};
